import { Component, Input, OnInit } from '@angular/core';
import {
  HANDOVER_TYPE_HO2_ID,
  HANDOVER_TYPE_HO3_ID,
  PERMISSION_ENGINEERING_COMPLETION,
} from 'src/app/handover-constants';
import { Handover } from 'src/app/interfaces/handover';
import { UserService } from 'src/app/services/user.service';
import { SectionTouched } from '../shared/section-touched.class';
import { HandoverService } from 'src/app/services/handover.service';
import { HandoverRelation } from 'src/app/interfaces/handover-relation';
import { promise } from 'protractor';
import { AnyMxRecord } from 'dns';

@Component({
  selector: 'app-handover-detail-location',
  templateUrl: './handover-detail-location.component.html',
  styleUrls: ['./handover-detail-location.component.scss'],
  standalone: false,
})
export class HandoverDetailLocationComponent
  extends SectionTouched
  implements OnInit
{
  @Input() handover: Handover | undefined;
  @Input() handoverRelation: HandoverRelation | undefined;
  @Input() readOnlyContent!: boolean;

  canUserEdit = false;
  constructor(private userService: UserService) {
    super();
  }

  ngOnInit(): void {
    if (this.handover) {
      this.canUserEdit =
        this.handover.handoverTypeId != HANDOVER_TYPE_HO3_ID
          ? true
          : !this.userService.hasPermission(PERMISSION_ENGINEERING_COMPLETION);
      this.readOnlyContent = this.readOnlyContent || !this.canUserEdit;
      if (this.handoverRelation) {
        this.readOnlyContent =
          this.readOnlyContent ||
          this.handoverRelation.handoverLocationId != null;
      }
    }
  }
}
